<div class="searchable-dropdown relative">
    <input type="text" id="address"
           class="w-full bg-gray-50 border border-gray-200 rounded h-10 px-2"
           placeholder=""
           [ngModel]="addressText()"
           [disabled]="isDisabled()"
           readonly
           (click)="toggleDropdown()">
    @if (isListVisible) {
        <ul class="list absolute w-full bg-bg-white border-gray-200 rounded mt-1 max-h-60 overflow-y-auto">
            @for (option of options(); track option) {
                <li class="item p-2 hover:bg-gray-100 cursor-pointer" (click)="onOptionSelected(option.id)">
                    {{ option.text }}
                </li>
            }
        </ul>
    }
    <label for="address" class="floating-lbl absolute left-2 -top-2.5 bg-white px-1 text-sm text-gray-600">
        {{ labelName }} <span class="text-red-700">*</span>
    </label>
</div>